export const UPDATE_PRODUCT_WARRANTY_CLAIMS = 'UPDATE_PRODUCT_WARRANTY_CLAIMS'
export const UPDATE_PRODUCT_WARRANTY_CLAIMS_SUCCESS = 'UPDATE_PRODUCT_WARRANTY_CLAIMS_SUCCESS'
export const UPDATE_PRODUCT_WARRANTY_CLAIMS_FAILED = 'UPDATE_PRODUCT_WARRANTY_CLAIMS_FAILED'

export const GET_PRODUCT_WARRANTY_CLAIMS = 'GET_PRODUCT_WARRANTY_CLAIMS'
export const GET_PRODUCT_WARRANTY_CLAIMS_SUCCESS = 'GET_PRODUCT_WARRANTY_CLAIMS_SUCCESS'
export const GET_PRODUCT_WARRANTY_CLAIMS_FAILED = 'GET_PRODUCT_WARRANTY_CLAIMS_FAILED'
